/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_Readonly_BodyInputs */



/**
* | output |
* | --- |
* | "Adding a conversation to Wundo changes nothing in your calendar. Planning, moving and cancelling happen there." |
*
* @param {Agenda_Source_Readonly_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_readonly_body = /** @type {((inputs?: Agenda_Source_Readonly_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_Readonly_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een gesprek aan Wundo toevoegen verandert niets aan je agenda. Inplannen, verzetten en annuleren doe je daar.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une conversation à Wundo ne change rien à votre agenda. Planifier, déplacer et annuler se font là-bas.")
	return /** @type {LocalizedString} */ ("Adding a conversation to Wundo changes nothing in your calendar. Planning, moving and cancelling happen there.")
});